import { CardLoader } from 'components/organisms'
import PaymentMethodTableRow from './payment-method-table-row'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import { PaymentMethodPagination } from 'domains/payment-method/components'

const propTypes = {
  tableProps            : PropTypes.object,
  paymentMethods        : PropTypes.array,
  pagination            : PropTypes.object,
  onPageChange          : PropTypes.func,
  isLoading             : PropTypes.bool,
  onClickChangeIsActive : PropTypes.func,
  onClickDetail         : PropTypes.func
}

const defaultProps = {
  isLoading: true
}

/**
 * Table to display specific ::TlPaymentMethod columns
 * @param {Array<Object>} data - array of payment_method_rate objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onPageChange - function that will handle Page Change
 * @param {Boolean} isLoading - boolean for withLoader animation
 */

const PaymentMethodTable = ({
  tableProps,
  paymentMethods,
  pagination,
  isLoading,
  onPageChange,
  onClickDetail,
  onClickChangeIsActive
}) => {

  const totalColumns         = 11
  const isPaymentMethodEmpty = paymentMethods.length === 0

  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <th colSpan={ 5 } className='text-center'>
          { 'Payment Methods' }
        </th>
        <th colSpan={ 5 } className='text-center'>
          { 'Rates' }
        </th>
      </thead>
      <thead>
        <tr>
          <th scope="col">id</th>
          <th scope="col">name</th>
          <th scope="col">category</th>
          <th scope="col">gateway</th>
          <th scope="col">status</th>
          <th scope="col">calculation type</th>
          <th scope="col">abs val customer</th>
          <th scope="col">abs val actual</th>
          <th scope="col">perc val customer</th>
          <th scope="col">perc val actual</th>
          <th scope="col">action</th>
        </tr>
      </thead>
      <tbody>
        {
          paymentMethods.map((paymentMethod) => (
            <PaymentMethodTableRow
              key={ `PaymentMethodTableRow-${paymentMethod.id}` }
              paymentMethod={ paymentMethod }
              onClickDetail={ onClickDetail }
              onClickChangeIsActive={ onClickChangeIsActive }
            />
          ))
        }
        {
          isPaymentMethodEmpty && (
            <tr>
              <td
                colSpan={ totalColumns }
                className='bg-warning text-white'
              >
                <i className='fas fa-info-circle mr-3' />
                { 'No Payment Methods found based on your filters.' }
              </td>
            </tr>
          )
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <PaymentMethodPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}


PaymentMethodTable.propTypes    = propTypes
PaymentMethodTable.defaultProps = defaultProps

export default PaymentMethodTable
